import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cipo-load-error',
  imports: [FlexLayoutModule, MatButtonModule, TranslateModule],
  template: `
    <div [fxLayout]="layout()" [fxLayoutAlign]="alignment()" fxLayoutGap="16px" [class]="spacing()">
      <span role="alert">{{ message() | translate }}</span>
      <button mat-stroked-button [attr.data-testid]="testId()" (click)="retry.emit()">
        {{ retryLabel() | translate }}
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadErrorComponent {
  readonly message = input.required<string>();
  readonly retryLabel = input('actions.retry');
  readonly testId = input('cipo-load-error-retry');
  /** `row` for a block sitting inside content that is otherwise fine, `column` for an empty pane. */
  readonly layout = input<'row' | 'column'>('column');
  readonly spacing = input('p-a-xl');

  readonly retry = output();

  readonly alignment = computed(() => (this.layout() === 'row' ? 'start center' : 'center center'));
}
